import React, { useState } from "react";
import "./ReviewCardComponent.css";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import RatingSubmittedModal from "../../Common-Component/Common_Modal/RatingSubmittedModal/RatingSubmittedModal";
import { useDispatch } from "react-redux";
import { reviewPost } from "../../../features/review_rating/review_ratingSlice";

const ReviewCardComponent = ({ order }) => {
  const [selectedStars, setSelectedStars] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [ratingError, setRatingError] = useState("");
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    if (selectedStars === 0) {
      setRatingError("Rating is required");
      return;
    }

    setRatingError("");

    const formData = {
      ...data,
      product_id: order.Product?.id,
      order_detail_id: order?.id,
      ratings: selectedStars,
    };
    dispatch(reviewPost(formData));
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
      reset();
      setSelectedStars(0);
        navigate("/home");
    }, 2000);
  };

  const handleStarClick = (index) => {
    setSelectedStars(index + 1);
  };

  return (
    <section className="ReviewCardComponent">
      <div className="first_div">
        <p className="question_text">
          How was your delivery experience with Shiprocket?
        </p>
        <div className="star_holder">
          {[...Array(5)].map((_, index) => (
            <p
              key={index}
              className="star_text"
              onClick={() => handleStarClick(index)}
            >
              <FontAwesomeIcon
                icon={faStar}
                className={`icon_star ${index < selectedStars ? "active" : ""}`}
              />
            </p>
          ))}
       
        </div>
           {ratingError && <p className="text-danger">{ratingError}</p>}
      </div>

      <div className="second_div">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="form-group">
            <Form.Label>Share design instruction here</Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Additional Information"
              {...register("review", {
                required: "Instruction is required",
              })}
            />
            {errors.review && (
              <p className="text-danger">{errors.review.message}</p>
            )}
          </Form.Group>

          <div className="submit_btn_holder">
            <Black_Btn btnText="Submit" type="submit" />
          </div>
        </Form>
      </div>

      <RatingSubmittedModal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText="Rating Submitted Successfully!"
      />
    </section>
  );
};

export default ReviewCardComponent;

// import React, { useState } from "react";
// import "./ReviewCardComponent.css";
// import { faStar } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Form } from "react-bootstrap";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
// import RatingSubmittedModal from "../../Common-Component/Common_Modal/RatingSubmittedModal/RatingSubmittedModal";

// const ReviewCardComponent = ({ order }) => {
//   const [selectedStars, setSelectedStars] = useState(0);
//   const [showModal, setShowModal] = useState(false);
//   const navigate = useNavigate(); // Initialize useNavigate

//   const handleStarClick = (index) => {
//     setSelectedStars(index + 1);
//   };

//   const handleSubmit = () => {
//     setShowModal(true);

//     setTimeout(() => {
//       setShowModal(false);
//       navigate("/home");
//     }, 2000);
//   };

//   return (
//     <section className="ReviewCardComponent">
//       <div className="first_div">
//         <p className="question_text">
//           How was your delivery experience with Shiprocket?
//         </p>
//         <div className="star_holder">
//           {[...Array(5)].map((_, index) => (
//             <p
//               key={index}
//               className="star_text"
//               onClick={() => handleStarClick(index)}
//             >
//               <FontAwesomeIcon
//                 icon={faStar}
//                 className={`icon_star ${index < selectedStars ? "active" : ""}`}
//               />
//             </p>
//           ))}
//         </div>
//       </div>

//       <div className="second_div">
//         <Form>
//           <Form.Group className="form-group">
//             <Form.Label>Share design instruction here</Form.Label>
//             <Form.Control
//               type="text"
//               as={"textarea"}
//               name="name"
//               placeholder="Additional Information"
//             />
//           </Form.Group>

//           <div className="submit_btn_holder" onClick={handleSubmit}>
//             <Black_Btn btnText="Submit" />
//           </div>
//         </Form>
//       </div>

//       <RatingSubmittedModal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         successText={"Rating Submitted Successfully!"}
//       />
//     </section>
//   );
// };

// export default ReviewCardComponent;
